import Ladda from 'ladda';
import 'dotdotdot';

let laddaLoadMore;
let waypoint;

const handlers = {
  showFlagShareHandler(e) {
    $(e.currentTarget)
      .find('div.comment__item__actions')
      .show()
    ;
  },
  hideFlagShareHandler(e) {
    $(e.currentTarget)
      .find('div.comment__item__actions')
      .hide()
    ;
  },
};

const _bindUIActions = function _bindUIActions() {
  // Response box
  $('div.response__content.rounded').on('click', '.response__content__like', (e) => {
    e.preventDefault();
    $(e.currentTarget).trigger('vs:app:community-response:comment:like');
  });

  // Replies
  $('div.comment-container').on('click', 'button.btn.comment__item__recommend', (e) => {
    $(e.currentTarget).trigger('vs:app:community-response:comment:like');
  });

  $('div.comment-container').on('mouseover', '.comment:not(.deleted)', handlers.showFlagShareHandler);

  $('div.comment-container').on('mouseout', '.comment:not(.deleted)', handlers.hideFlagShareHandler);

  // See More button
  $('div.comments').on('click', '.comment__item__content__see-more', (e) => {
    e.preventDefault();
    const comment = $(e.currentTarget).parent();
    comment.trigger('destroy');
    comment.css('max-height', 'none');
  });

  $('#comments__see-more').on('vs:ui:community-response:comment:see_more:start', (e) => {
    $(e.currentTarget).prop('disabled', true);
    laddaLoadMore = Ladda.create(document.querySelector('#comments__see-more__label'));
    laddaLoadMore.start();
  });

  $('#comments__see-more').on('vs:ui:community-response:comment:see_more:stop', (e) => {
    $(e.currentTarget).prop('disabled', false);
    laddaLoadMore.stop();
    $(e.currentTarget).trigger('vs:ui:community-response:comment:see_more:waypoints:init');
  });

  $('#comments__see-more').on('vs:ui:community-response:comment:see_more:waypoints:init', (e) => {
    if ($(window).width() > 544) {
      if (waypoint) {
        Waypoint.refreshAll();
      } else {
        waypoint = $('#comments__see-more').waypoint({
          handler(direction) {
            if (!$('#comments__see-more').prop('disabled')) {
              $('#comments__see-more').trigger('vs:app:community-response:comment:load_more');
            }
          },
          offset: 'bottom-in-view',
        });
      }
    }
  });

  $('#comments__see-more').on('vs:ui:community-response:comment:see_more:waypoints:destroy', (e) => {
    $(e.currentTarget).hide();
    $(e.currentTarget).prop('disabled', true);
    if (waypoint) {
      Waypoint.destroyAll();
    }
  });

  $('#comments__see-more').on('click', (e) => {
    $('#comments__see-more').trigger('vs:app:community-response:comment:load_more');
  });

  // Body - parentComment + response + replies
  const $body = $('div.response');

  // Delete comment modal
  $body.on('click', '.modal--delete-comment-confirm .comment__delete__delete', (e) => {
    const commentId = $(e.target).data('id');
    $(e.currentTarget).trigger('vs:app:community-response:comment:delete', commentId);
  });

  $body.on('click', '.btn.comment__item__delete', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const commentId = $(e.target).data('id');
    $('.modal--delete-comment-confirm .comment__delete__delete').data('id', commentId);
    $(e.target).trigger('vs:ui:community-response:comment:delete:toggle');
  });

  $body.on('vs:ui:community-response:comment:delete:toggle', (e) => {
    $('.modal--delete-comment-confirm').modal('toggle');
    $('#modal--delete-comment-confirm')
      .find('comment__delete__delete')
      .focus()
    ;
  });

  $body.on('click', '.js-comment-share-facebook, .js-comment-share-twitter, .js-comment-share-email', (e) => {
    const commentId = $(e.currentTarget).data('id');
    const type = $(e.currentTarget).data('type');
    $(e.currentTarget).trigger('vs:app:community-response:comment:share', [commentId, type]);
  });
};

const registerEventBindings = function registerEventBindings() {
  _bindUIActions();
};

const UICommunityResponse = {
  registerEventBindings,
  handlers,
};

export default UICommunityResponse;
